//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.Feature.js";
import "../no/DesignSimulation.js";
let d=[[[0,"ActiveStudy",0,"DesignSimulation.Study",0],[0,"ActiveSubcase",0,"DesignSimulation.Subcase",0],[0,"DelayUpdate",1,0]],[[["optimizationStudy"],"CreateStudyBuilder",{R_:{builder:"DesignSimulation.StudyBuilder"}},1,0],[["studyCount","optimizationStudies"],"GetAllStudies",{},0,0],[["optimizationStudy"],"MakeStudyActive",{},1,0],[["subcase"],"MakeSubcaseActive",{},1,0],[["existingStudy"],"CloneStudy",{R_:{clonedStudy:"DesignSimulation.Study"}},1,0],[["journalIdentifier"],"FindObject",{R_:{found:"INXObject"}},1,0],[["existingStudy","fileNameAndPath"],"ExportStudyToJsonFile",{},2,0],[["fileNameAndPath"],"CreateStudyFromJsonFile",{R_:{importedStudy:"DesignSimulation.Study"}},1,0]],[]];
SPLM.Features.TopologyOptimizationFeature = class extends SPLM.Features.Feature{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.TopologyOptimizationFeature";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;